"use strict";

exports.__esModule = true;
var _ReportCollection = require("./ReportCollection");
Object.keys(_ReportCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportCollection[key]) return;
  exports[key] = _ReportCollection[key];
});
var _ReportCollectionContext = require("./ReportCollectionContext");
Object.keys(_ReportCollectionContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportCollectionContext[key]) return;
  exports[key] = _ReportCollectionContext[key];
});